import React, { useContext } from 'react'
import { useAuthContext, QuestionContext } from '../../../../Context'
import type { Question } from '../../../../Api'
import { SummaryRowStyle } from './styles'

type QuestionProps = {
  question: Question
  index: number
}

export const SummaryRow: React.FC<QuestionProps> = ({ question, index }) => {
  const { goToQuestion } = useContext(QuestionContext)!
  const { isLoggedIn, login } = useAuthContext()

  const getAnswerLabel = (answerCode: string | number) => {
    const matchedAnswer = question.answerChoices.find((a) => a.code === answerCode)
    if (matchedAnswer) {
      return matchedAnswer.value
    } else {
      return
    }
  }

  const onSelectSummaryRow = () => {
    if (!isLoggedIn) {
      return login()
    }
    goToQuestion(index)
  }

  const checkCorrect = (q: Question) => {
    if (!q.userAnswerCode || !q.correctAnswerCode) return 'neutral'
    if (q.userAnswerCode === q.correctAnswerCode) {
      return 'correct'
    }
    if (q.userAnswerCode !== q.correctAnswerCode) {
      return 'incorrect'
    }
    return 'neutral'
  }

  return (
    <>
      <SummaryRowStyle
        selected={!question.userAnswerCode ? false : true}
        correct={checkCorrect(question)}
        onClick={onSelectSummaryRow}
      >
        <div className="circleCon">
          <div className="circle"></div>
        </div>
        <div className="questionCon">
          <div className="question">{question.question}</div>
          {question.userAnswerCode && (
            <div className="selectedText">{`Selected: ${getAnswerLabel(
              question.userAnswerCode
            )}`}</div>
          )}
          {!question?.userAnswerCode && (
            <div className="unselectedText">{'Select Answer'}</div>
          )}
        </div>
      </SummaryRowStyle>
    </>
  )
}
